import { render, staticRenderFns } from "./rankManage.vue?vue&type=template&id=5ad8cea5&"
import script from "./rankManage.vue?vue&type=script&lang=js&"
export * from "./rankManage.vue?vue&type=script&lang=js&"
import style0 from "./rankManage.vue?vue&type=style&index=0&id=5ad8cea5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports